import semaphoreReducer from './semaphore';
export * from './semaphore';

export default { semaphore: semaphoreReducer };
